import type { ListBuilderList } from '../../../types';
import { createHighTempMerchandiserColumns } from '../columns';
import { MERCHANDISER_REQUIRED_FIELDS } from '../shared';

/**
 * High Temp Merchandisers list configuration
 * Shows merchandiser locations with temperature above 40°F
 */
export const highTempMerchandisersList: ListBuilderList = {
	id: 'high-temp-merchandisers',
	cacheTTL: 600000,
	name: 'High Temp Merchandisers',
	type: 'default',
	active: true,
	columns: createHighTempMerchandiserColumns(),
	description: 'Merchandiser locations with temperature above 40°F',
	defaultSortId: 'column-location-code-asc',
	filterRules: {
		locationType: {
			defaultValue: [{ id: 'merchandiser', label: 'Merchandiser' }],
		},
		highTemp: {
			defaultValue: [{ id: 'high', label: 'High' }],
		},
	},
	requiredFields: MERCHANDISER_REQUIRED_FIELDS,
	sortOrder: 6,
};
